import Ajax from "base/Ajax";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Page from "webPage/Page";

Page.register(new RegExp('^/customers/([0-9a-f]+)/invoices/([0-9a-f]+)/?$'), ([customer_id, invoice_id]) => {
    let form = new AjaxForm($(".container"), ($form, formData) => {
        return Ajax.post("billing", "invoices/" + invoice_id, $.extend({customer: customer_id}, formData));
    });

    form.on(EVENT_SUCCESS, (data) => {
        Message.schedule(new Message('The invoice has been updated successfully', 'Invoice updated', Message.SUCCESS));
        window.location.reload();
        return false;
    });

    $("body").on("click", ".js-dismiss-po-warning", function () {
        let modal = new AjaxConfirmModal("Are you sure you want to dismiss the missing Purchase Order?", undefined, async () => {
            await Ajax.post("billing", "invoices/" + invoice_id + "/dismiss-po-warning");
        });
        modal.on("success", () => {
            window.location.reload();
        });
        modal.show();
        return false;
    }).on("click", ".js-send-invoice", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to send/resend the invoice via email?", undefined, async () => {
            return Ajax.post("billing", "invoices/" + invoice_id + "/send-email", {reason: 1 /* Invoice */});
        });
        modal.on("success", (email) => {
            new Message("The invoice has been successfully sent to " + (email.recipients.map((recipient) => recipient.emailAddress).join(", ")), "Invoice Sent", Message.SUCCESS, {
                autoHide: false,
            });
            modal.destroy();
        });
        modal.show();
        return false;
    }).on("click", ".js-send-receipt", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to send/resend the receipt via email?", undefined, async () => {
            return Ajax.post("billing", "invoices/" + invoice_id + "/send-email", {reason: 2 /* Receipt */});
        });
        modal.on("success", (email) => {
            new Message("The receipt has been successfully sent to " + (email.recipients.map((recipient) => recipient.emailAddress).join(", ")), "Receipt Sent", Message.SUCCESS, {
                autoHide: false,
            });
            modal.destroy();
        });
        modal.show();
        return false;
    }).on("click", ".js-start-chasing", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to start the chasing process for this invoice? This will send the first reminder immediately", undefined, async () => {
            return Ajax.post("billing", "invoices/" + invoice_id + "/start-chasing");
        });
        modal.on("success", () => {
            new Message("The chasing process has successfully started", "Chasing Begun", Message.SUCCESS, {
                autoHide: false,
            });
            modal.destroy();
        });
        modal.show();
        return false;
    });
});
